import styles from "./RedBar.module.scss";
import Text from "../../Text/Text";
import Icons from "../../../../assets/icons";
import {Link} from "react-router-dom";

const warning = Icons.redWarrnig;

const RedBar = ({ text, buttonText, buttonLink }) => {
  return (
    <div className={styles.Wrapper}>
      <div>
        {warning}
        <Text red s18>
          {text}
        </Text>
      </div>
      {buttonText && buttonLink && (
        <div>
        <Link to={buttonLink} rel="noreferrer" target="_blank">
          <Text red s18 underline>
            {buttonText} »
          </Text>
        </Link>
      </div>
      )}
    </div>
  );
};

export default RedBar;
